import React, { useMemo } from 'react';
import styled from 'styled-components';
import { RowType } from '../../../../../redux/slices/oldBuilder';
import { IRowMeta } from '../../../../../redux/slices/oldBuilder';
import { filterPrimitiveSelector } from '../../../../../redux/selectors/builder';
import { useAppSelector } from '../../../../../redux/hooks';
import { MaybeNil } from '../../../../../utils/interfaces';
import { IFilterFieldsFragment } from '../../../../../utils/apollo/graphqlSchema';
import SectionHeading from '../../../../../components/SectionHeading';
import { EventCondition } from '../../../../../components/Builder/BuilderFields';
import TriggerSubject from './TriggerSubject';
import { queryImpactAnalysisInfo } from '../../../../../components/KubitTooltip/globalTooltips';
import {
  useActionsVisibilityContext,
  withActionsVisibilityContext,
} from '../../../../../components/ActionsVisibilityContext';
import ThinDivider from '../../../../../components/ThinDivider';
import { borderedContent } from '../../../../../styles/shareableStyles';

const rowMeta: IRowMeta = {
  rowType: RowType.trigger,
  rowIndex: 0,
};

const Container = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: start;
  column-gap: 8px;
  padding: 8px 16px;
  ${borderedContent};
`;

const SubjectWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-top: 7px;
`;

const ImpactAnalysis = () => {
  const filterSelector = useMemo(filterPrimitiveSelector, []);
  const filter: MaybeNil<IFilterFieldsFragment> = useAppSelector((state) =>
    filterSelector(state, rowMeta),
  );

  const { showActions, hideActions } = useActionsVisibilityContext();

  return (
    <>
      <SectionHeading
        heading="Impact Analysis"
        tooltipOption={queryImpactAnalysisInfo}
      />
      <Container onMouseEnter={showActions} onMouseLeave={hideActions}>
        <SubjectWrapper>
          <TriggerSubject />
          <ThinDivider layout="vertical" size="short" />
        </SubjectWrapper>
        <EventCondition
          placeholder="Select event that will impact your measure"
          rowMeta={rowMeta}
          label={'Trigger Event(s)'}
          filter={filter}
          canRenderFilters
        />
      </Container>
    </>
  );
};

export default withActionsVisibilityContext(ImpactAnalysis);
